import { type CSSResultArray, html, LitElement, type TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";

import styles from "./api-preview.scss";

@customElement("oz-api-preview")
export class ApiPreview extends LitElement {
	public static override styles: CSSResultArray = [styles];

	private readonly _request = {
		languageCode: "cs",
		currencyCode: "CZK",
		category: "SellingIntent",
		propertyType: "Flat",
		area: 50,
		addressCode: "22061274",
		age: "NewBuild",
		state: "New",
		disposition: "TwoPlusKitchen",
		ownership: "Personal",
		floor: 3,
		elevator: true,
	};

	protected override render(): TemplateResult {
		return html`
			<div class="api">
				<div class="endpoint">
					<strong class="method">POST</strong>
					<strong>/v1/estimations</strong>
					<span class="format">JSON</span>
				</div>
				<pre><code>${JSON.stringify(this._request, null, 2)}</code></pre>
			</div>
		`;
	}
}
